import { App, View } from "@pimo/pimo-app-builder";
import {
  DragAndDropLayout,
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
  PMSmallNumberProps,
} from "@pimo/pimo-components";

import { TestAppState } from "../../../app";
import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getItemName,
  getPluralOfItemName,
} from "../../../utils/get-plural-of-item-name";
import { getProjectName } from "../../../utils/get-plural-of-project-name";
import { makeGetCardCopy } from "../card-copy";

/** Adds the number-of-items card (#2222). */
export function addNumberOfItemsCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";
  const getCardCopy = makeGetCardCopy(app);

  const numberOfItemsComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfItemsComponent",
      labels: ["#ofItems"],
      description: getCardCopy(language, "reportNumberOfItems").description,
      title: getCardCopy(language, "reportNumberOfItems").title,
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfItemsComponent.mapState(
    ({ currentReport, reportComponentValues, ...appState }) => {
      const a: PMSmallNumberProps | undefined = reportComponentValues?.[
        "numberOfItemsComponent"
      ] as PMSmallNumberProps | undefined;
      return {
        showInfoIcon: false,
        showMenuIcon: false,
        title:
          a?.title ??
          getLocalizedCardCopy(
            appState.language || "en",
            "reportNumberOfItems",
            {
              itemName: getItemName(
                appState.settings?.configuration?.itemName,
                appState.language || "en"
              ),
              itemNamePlural: getPluralOfItemName(
                appState.settings?.configuration?.itemName,
                appState.language || "en"
              ),
              projectName: getProjectName(
                appState.settings?.configuration?.projectName,
                appState.language || "en"
              ),
            }
          ).title,
        number:
          a?.number ??
          currentReport?.project?._calculated?.numberOfSubEntities ??
          0,
      };
    }
  );
}
